export const PRIVACY_POLICY = 'https://www.notchordering.com/company/privacy';
export const TERMS_OF_USE = 'https://www.notchordering.com/usageterms';
export const HELP_DESK = 'https://intercom.help/notchordering/en/';
export const LETS_TALK = 'https://www.notch.financial/company/lets-talk';
